<template>
    <div class="search-box position-relative" v-click-outside="hidePopup">
        <i class="fas fa-search mr-2" style="color: gray"></i>
        <input type="text" class="search-input" :placeholder="$t('message.InputQuickSearch.placeholder.order_supplier')"
               v-model.trim="keyword" @input="onSearchOrder" :readonly="readonly"/>
        <div class="popup-product-search" v-if="keyword">
            <ul class="wrap-products" v-if="orders.length">
                <li v-for="order in orders" :key="order.id" @click="onSelect(order)">
                    <div class="product-info">
                        <span class="branch__name">{{ order.code }}</span>
                        <span class="branch__contactNumber">{{ order.orderDate }}</span>
                    </div>
                </li>
            </ul>
            <div v-else class="products-not-found">
                <span>
                    {{ $t('message.common.notFound') }}
                </span>
            </div>
        </div>
    </div>
</template>

<script>
    import {$alert, $get, debounce} from "@/lib/utils";
    import store from "@/store";
    let app;

    export default {
        name: "OrderSupplierSearch",
        emits: ['select'],
        props: ['readonly'],
        data() {
            app = this;
            return {
                orders: [],
                keyword: '',
            }
        },
        methods: {
            onSearchOrder: debounce(async () => {
                app.callOSearchOrder();
            }),
            async callOSearchOrder() {
                if (this.keyword) {
                    const res = await $get('/v1/order-suppliers/search-order-by-code', {
                        keyword: this.keyword,
                        branchId: store.state.CurrentBranch.id,
                    });
                    if (res.status.code == 200) {
                        this.orders = res.result;
                    } else {
                        $alert(res);
                    }
                }
            },
            onSelect(order) {
                this.$emit('select', order);
                this.orders.length = 0;
                this.keyword = '';
            },
            hidePopup() {
                this.keyword = '';
                this.orders.length = 0;
            },
            showModalProductsAdd(){
                if (!this.readonly) {
                    this.$refs.ModalProductsAdd.show();
                }
            },
        }
    }
</script>

<style scoped lang="scss">
@import "../assets/css/vars.scss";
    .popup-product-search {
        position: absolute;
        top: 100%;
        left: 0;
        width: 100%;
        min-width: 450px;
        z-index: 10;
        padding-bottom: 20px;
        /*padding-bottom: 50px;*/

        max-height: calc(100vh - 230px);
        font-size: 14px;
        background: #fff;

        border-radius: 5px;
        box-shadow: 0 5px 15px rgb(0 0 0 / 35%);

        ul.wrap-products {
            padding: 10px 0;
            overflow: auto;
            max-height: calc(100vh - 284px);
            list-style: none;
            margin-bottom: 0;

            li {
                cursor: pointer;
                padding: 10px 20px;
                margin: 0;

                .product-img {
                    width: 55px;
                    height: 55px;
                    text-align: center;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    float: left;
                    margin-left: -5px;
                    margin-top: 0;

                    img {
                        max-width: 100%;
                        max-height: 100%;
                        vertical-align: middle;
                    }
                }

                .product-info {
                    margin-left: 60px;
                    line-height: 18px;
                    display: flex;
                    justify-content: space-between;

                    p {
                        margin-bottom: 2px;
                    }

                    .name-item {
                        font-weight: bold;
                        word-break: break-word;
                    }

                    .code-item, .price-item {
                        margin-right: 20px;
                        margin-left: 0;
                    }
                }
            }

            li:hover {
                background-color: $base-color;
                color: #fff;
            }

            &::-webkit-scrollbar {
                width: 8px;
                height: 8px;
            }

            &::-webkit-scrollbar-thumb {
                width: 8px;
                border-radius: 4px;
                background-color: #c1c1c1;
                border: 1px solid #fff;
            }

            &::-webkit-scrollbar-track {
                padding: 6px;
            }
        }

        .products-not-found {
            padding: 25px 10px;
            color: #999999;
            text-align: center;
        }

        .add-new-product {
            line-height: 50px;
            position: absolute;
            left: 0;
            bottom: 0;
            width: 100%;
            text-align: center;
            border-top: 1px solid #ebebeb;
            cursor: pointer;

            &:hover {
                background-color: $base-color;
                color: #fff;
            }
        }
    }
</style>
